import React, { useEffect, useState } from "react";
import { Grid, Tooltip, Box } from "@mui/material";
import DataModal from "../../../shared/DynamicModal";
import EditableTable from "../../../shared/EditableTable/EditableTable";
import CustomEditComponent from "./CustomEditComponent";
import CustomEditSelect from "./CustomEditSelect";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useDispatch } from "react-redux";
import { AddCustomerFile } from "../../state/actions";
import { notificationType, docType } from "../../../../utils/constantDropdowns";

import _ from "lodash";

const CustomerFileTable = ({customerFileData,  failedCustomers , ...props }) => {
  const dispatch = useDispatch()
  const [tableRef, setTableRef] = useState(null);
  const [finallRows, setRows] = useState(customerFileData);
  const [selectedRows, setSelectedRows] = useState([]);
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
  const [getError, setErrors] = useState();

  const accNum = ["1221300396"];
  const selectedRowsWithDetails = finallRows
    .filter((row, index) =>
      selectedRows.includes(`${index}-${row?.account.data}`)
    )
    .map((row, index) => ({
      ...row,
      id: { valid: true, message: "", data: `${index}-${row?.account.data}` },
    }));

  let testselected = selectedRowsWithDetails
    .filter((row, index) => failedCustomers?.includes(row.account.data))
    .map((row, index) => ({
      ...row,
    }));
  useEffect(() => {
    if (testselected.length > 0) {
      setRows(
        finallRows?.map((row, index) =>
          `${row?.account.data}` == failedCustomers.map((id) => id)
            ? {
                ...row,
                isReturn: { valid: true, Returned: true },
              }
            : row
        )
      );
    }
  }, [failedCustomers?.length]);

  /* useEffect(() => {
 if(customerFileData?.length > 0)
 {
  debugger  
  let rows = [];

  for(let i = 0; i < customerFileData?.length ; i++)
  {
    let row = {};
 
   
    let map = Object.keys(customerFileData[i]);
    map.forEach(element => {
      row[element] = customerFileData[i][element].data;
    });
    rows.push(row);
  }
  //setRows(rows)

 }
  
},[customerFileData])
 */
  //const [data, setData] = useState(customerFileData);
  const handleCloseTable = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    props.setOpenTable(false)
    props.setOpen(false)
  }

  const onSelectionChange = (rows) => {
    setSelectedRows(rows);
  };

  const AreSelectedRowsValid = (rows) => {
    return rows.every((item) => item);
  };

  const handleClickOpenTable = () => {
    let rows = [];
    let ArrayofValid = [];
    selectedRowsWithDetails?.forEach((row, rowIndex) => {
      let disableBtn = Object.keys(row)?.every((key) => row[key]?.valid);

      ArrayofValid.push(disableBtn);
    });

    let isValid = AreSelectedRowsValid(ArrayofValid);

  for(let i = 0; i < selectedRowsWithDetails?.length ; i++)
  {
    let row = {};
  //var disableBtn = Object.keys(finallRows[i])?.some((key) => !finallRows[key]?.valid)
    let map = Object.keys(selectedRowsWithDetails[i]);
    map.forEach(element => {
      row[element] = selectedRowsWithDetails[i][element].data;
    });
    let getSelectedGroup = props.Groups.filter((group) => group.name.trim().toLowerCase() === row.group.trim().toLowerCase())[0]
    let getDocType = docType.filter((doc) => doc.trim().toUpperCase() === row.documentType.trim().toUpperCase())[0]
    let getOtherAcc = selectedRowsWithDetails[i]["otherAccounts"].data?.split(";").map((item) => item.trim()).filter(elm => elm)
  delete row.id
    delete row.group
    let data = {
      ...row,
      otherAccounts : getOtherAcc ? getOtherAcc : [],
      notificationType : "EMAIL",
      documentType : getDocType ? getDocType : "PDF",
      safety : "NORMAL",
      password : '',
      type : "GROUP",
      groupIds : getSelectedGroup ? [getSelectedGroup?.id] : []
    }
    rows.push(data);
 }

if(!isValid || selectedRowsWithDetails.length === 0)
{
  if(selectedRowsWithDetails.length === 0) {
    return props.error("No customers are selected")
  }
  
  return props.error("Please make sure that all the selected rows are valid")
}else {
  dispatch(AddCustomerFile(rows,props.success, props.error,props.setOpenTable,props.setOpen))
  //setOpenTable(false)
 
}
  }
    const columnDefaults = {
        sortable: false,
        flex: 1,
        filterable: true,
        minWidth: 250,
        editable: true,
      };
      

     
     /*  const preProcessEditCellProps = async (params) => {
        debugger
       return  ProcessEdit(params ,finallRows , fieldName)
      };
 */

  const validateAccountNumber = (data, row) => {
    if (data == row.account.data) return;

    const existingUsers = finallRows.map((row) => row["account"].data);
    const exists = existingUsers.includes(data);
    return exists ? `${data} is already taken.` : null;
  };

  const columns = [
    /*    {
          ...columnDefaults,
          field: "id",
          headerName: "ID",
          sortable:true,
          renderCell: (params) => {
            return params.value 
          },
          renderEditCell: (params) => (
            <CustomEditComponent {...params} />
          ),
          
        
        },  */
    {
      ...columnDefaults,
      field: "name",
      headerName: "Customer Name",

      preProcessEditCellProps: (params) => {
        var errorMessage = params.props.value.data !== "";
        if (errorMessage) {
          params.props.value.valid = true;
          params.props.value.message = "";
          params.row.name.valid = true;
          params.row.name.message = "";
        } else {
          params.props.value.valid = false;
          params.props.value.message = "name cant be empty";
          params.row.name.valid = false;
          params.row.name.message = "name cant be empty";
        }
        return { ...params.props, error: params.props.value.message };
      },
      renderCell: (params) => {
        return (
          <>
            {params.value.data}

            {params.value.message && (
              <Tooltip title={params.value.message}>
                <ErrorOutlineIcon
                  sx={{ color: params.value.valid ? "blue" : "red" }}
                />
              </Tooltip>
            )}
          </>
        );
      },
      renderEditCell: (params) => (
        <CustomEditComponent setErrors={setErrors} {...params} />
      ),
    },

    {
      ...columnDefaults,
      field: "email",
      headerName: "Email",
      preProcessEditCellProps: (params) => {
        let emailValidation = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        var errorMessage = emailValidation.test(params.props.value.data);
        if (errorMessage) {
          params.props.value.valid = true;
          params.props.value.message = "";
          params.row.email.valid = true;
          params.row.email.message = "";
        } else {
          params.props.value.valid = false;
          params.row.email.valid = false;
          params.row.email.message = "Invalid Email Adress";
          params.props.value.message = "Invalid Email Adress";
        }
        return { ...params.props, error: params.props.value.message };
      },
      renderCell: (params) => {
        return (
          <>
            {params.value.data}

            {params.value.message && (
              <Tooltip title={params.value.message}>
                <ErrorOutlineIcon
                  sx={{ color: params.value.valid ? "blue" : "red" }}
                />
              </Tooltip>
            )}
          </>
        );
      },
      renderEditCell: (params) => (
        <CustomEditComponent setErrors={setErrors} {...params} />
      ),
    },
    {
      ...columnDefaults,
      field: "emailCC",
      headerName: "Email CC",
      renderCell: (params) => {
        return (
          <>
            <Tooltip title={params?.value?.data}>
              <span className="table-cell-trucate"> {params.value.data}</span>
            </Tooltip>
            {params.value.message && (
              <Tooltip title={params.value.message}>
                <ErrorOutlineIcon
                  sx={{ color: params.value.valid ? "blue" : "red" }}
                />
              </Tooltip>
            )}
          </>
        );
      },
      renderEditCell: (params) => (
        <CustomEditComponent setErrors={setErrors} {...params} />
      ),
    },
    {
      ...columnDefaults,
      field: "account",
      headerName: "Account No.",
      preProcessEditCellProps: (params) => {
        var errorMessage =
          params.props.value.data.length == props.configurationData.accountLength;
        var checkIncludes = validateAccountNumber(
          params.props.value.data,
          params.row
        );
        if (errorMessage && !checkIncludes) {
          params.props.value.valid = true;
          params.row.account.valid = true;
          params.row.account.message = "";
          params.props.value.message = "";
        } else if (checkIncludes) {
          params.props.value.valid = false;
          params.props.value.message = checkIncludes;
          params.row.account.valid = false;
          params.row.account.message = checkIncludes;
        } else {
          params.props.value.valid = false;
          params.props.value.message = "wrong account number length";
          params.row.account.valid = false;
          params.row.account.message = checkIncludes;
        }
        let newRow = { ...params.row, account: params.props.value };
        // mySaveOnServerFunction(newRow,params.row)
        return { ...params.props, error: params.props.value.message };
      },
      renderCell: (params) => {
        return (
          <>
            {params.value.data}

            {params.value.message && (
              <Tooltip title={params.value.message}>
                <ErrorOutlineIcon
                  sx={{ color: params.value.valid ? "blue" : "red", flex: "1" }}
                />
              </Tooltip>
            )}
          </>
        );
      },
      renderEditCell: (params) => (
        <CustomEditComponent setErrors={setErrors} {...params} />
      ),
    },

        {
          ...columnDefaults,
          field: "documentType",
          headerName: "Document Type",
          renderCell: (params) => {
            return (
              <>
              {params.value.data}
                   {params.value.message && <Tooltip  title={params.value.message}>
                    <ErrorOutlineIcon sx={{color : params.value.valid ? "blue" : "red" , flex:'1'}}/>
                    </Tooltip>}
                </>
              ) 
          },
          renderEditCell: (params) => (
            <CustomEditSelect options={docType}  setErrors = {setErrors} {...params} />

          ),
         
        },
        {
          ...columnDefaults,
          field: "group",
          headerName: "Group",
          renderCell: (params) => {
            return (
              <>
              {params.value.data}
                   {params.value.message && <Tooltip  title={params.value.message}>
                    <ErrorOutlineIcon sx={{color : params.value.valid ? "blue" : "red" , flex:'1'}}/>
                    </Tooltip>}
                </>
              ) 
          },
          renderEditCell: (params) => (
            <CustomEditSelect options={props.Groups} optionsType={"Groups"} setErrors = {setErrors} {...params} />

          ),
         
        },
       /*  {
        ...columnDefaults,
        field:"notificationType",
        headerName:"Notification Type",
        renderCell: (params) => {
          return (
            <>
            {params.value.data}
                 {params.value.message && <Tooltip  title={params.value.message}>
                  <ErrorOutlineIcon sx={{color : params.value.valid ? "blue" : "red" , flex:'1'}}/>
                  </Tooltip>}
              </>
            ) 
        },
        renderEditCell: (params) => (
          <CustomEditSelect options={notificationType}  setErrors = {setErrors} {...params} />

        ),
        },
        {
          ...columnDefaults,
          field:"phoneNumber",
          headerName:"Phone Number",
          renderCell: (params) => {
            return (
              <>
              {params.value.data}
                   {params.value.message && <Tooltip  title={params.value.message}>
                    <ErrorOutlineIcon sx={{color : params.value.valid ? "blue" : "red" , flex:'1'}}/>
                    </Tooltip>}
                </>
              ) 
          },
          renderEditCell: (params) => (
            <CustomEditComponent setErrors = {setErrors}  {...params} />  
          ),
          }, */
    {
      ...columnDefaults,
      field: "otherAccounts",
      headerName: "Other Accounts",
      renderCell: (params) => {
        return (
          <>
            {params.value.data}
            <Tooltip title={" Add Accounts Separated by semicolons"}>
              <ErrorOutlineIcon
                sx={{ color: params.value.valid ? "blue" : "red", flex: "1" }}
              />
            </Tooltip>
          </>
        );
      },
      renderEditCell: (params) => (
        <CustomEditComponent setErrors={setErrors} {...params} />
      ),
    },
  ];

  const mySaveOnServerFunction = (newRow, originalRow, field) => {
    if (_.isEqual(newRow, originalRow)) {
      return originalRow;
    } else {
      const updatedRow = { ...newRow };
      setRows(
        finallRows?.map((row, index) =>
          `${index}-${row?.account.data}` == newRow.id.data ? updatedRow : row
        )
      );
      return updatedRow;
    }
  };

  return (
    <>
      <DataModal
        changeWidth="90%"
        onClose={handleCloseTable}
        open={props.openTable}
        discardChanges={handleCloseTable}
        HeadrTitle="Customer File"
        ButtonTitle="Save"
        saveChanges={handleClickOpenTable}
      >
        <Box>
          <Grid
            item
            xs={12}
            sx={{ height: 400, width: "100%" }}
            ref={(newTableRef) => setTableRef(newTableRef)}
          >
            <EditableTable
              {...{
                columns,
                tableRef,
                mySaveOnServerFunction,
                onSelectionChange,
                selectedRows,
              }}
              rows={
                finallRows?.length > 0 &&
                finallRows?.map((row, index) => ({
                  ...row,
                  id: {
                    valid: true,
                    message: "",
                    data: `${index}-${row?.account.data}`,
                  },
                }))
              }
            />
          </Grid>
        </Box>
      </DataModal>
    </>
  );
};

export default CustomerFileTable;
